import { render, staticRenderFns } from "./SmeltingProductInfoList.vue?vue&type=template&id=2289cf1e&"
import script from "./SmeltingProductInfoList.vue?vue&type=script&lang=js&"
export * from "./SmeltingProductInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports